<template>
  <div class="extra-insurance-page vue-dpn" style="padding: 0.5rem 0; text-align: left">
    <div style="position: fixed; top: 0; left: 0; right: 0; z-index: 999">
      <van-nav-bar title="追加投保" @click-left="goBack" left-arrow />
    </div>

    <div style="padding: 56px 0.4rem 1.2rem 0.4rem">
      <van-loading v-if="pageLoading" class="extra-page-loading" />
      <template v-else>
      <div v-if="planCode" class="extra-plan-hint">产品：{{ planCode }}</div>
      <div class="ps-text" style="padding: 0 0 0.2rem; text-align: left">
        追加名单与合同游客无关；身份证自动解析生日/性别，护照及其他证件需手动填写，手机号必填。
      </div>

      <div
        v-for="(person, index) in extraApplyPersons"
        :key="'extra-person-' + index"
        class="extra-person-block"
      >
        <div class="extra-person-title">
          <span>追加人员 {{ index + 1 }}</span>
          <van-button
            v-if="extraApplyPersons.length > 1"
            size="mini"
            type="danger"
            plain
            @click="removeExtraApplyPerson(index)"
          >
            删除
          </van-button>
        </div>
        <van-field v-model="person.name" label="姓名" placeholder="请输入姓名" />
        <van-field
          :value="extraCardTypeLabel(person.cardtype)"
          label="证件类型"
          placeholder="请选择"
          readonly
          is-link
          @click="openExtraCardTypePicker(index)"
        />
        <van-field
          v-model="person.idcard"
          label="证件号"
          placeholder="请输入证件号"
          @blur="onExtraIdcardBlur(person)"
        />
        <van-field
          v-model="person.birthday"
          label="出生日期"
          placeholder="YYYY-MM-DD"
          :readonly="isExtraBirthdayAuto(person)"
          @blur="formatExtraBirthday(person)"
        />
        <van-field
          :value="person.gender"
          label="性别"
          placeholder="请选择"
          readonly
          :is-link="!isExtraGenderAuto(person)"
          @click="openExtraGenderPicker(index, person)"
        />
        <van-field
          v-model="person.phone"
          label="手机号"
          placeholder="必填"
          type="tel"
        />
      </div>

      <van-button plain block @click="addExtraApplyPerson" style="margin-top: 0.2rem;">
        添加人员
      </van-button>
      <van-button
        type="primary"
        block
        :loading="extraApplySubmitting"
        @click="openExtraApplyConfirm"
        style="margin-top: 0.3rem;"
      >
        提交追加投保
      </van-button>
      </template>
    </div>

    <van-dialog
      v-model="extraApplyConfirmVisible"
      title="确认追加投保"
      show-cancel-button
      :before-close="handleExtraApplyConfirmClose"
    >
      <div class="extra-confirm-body">
        <p class="extra-confirm-disclaimer">{{ disclaimerText }}</p>
        <p class="extra-confirm-warning">{{ disclaimerWarnText }}</p>
        <van-checkbox v-model="extraApplyDisclaimerAgreed" shape="square">
          我已阅读并知晓上述说明
        </van-checkbox>
      </div>
    </van-dialog>

    <van-popup v-model="showExtraCardTypePicker" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="extraCardTypeOptions"
        @confirm="onExtraCardTypeConfirm"
        @cancel="showExtraCardTypePicker = false"
      />
    </van-popup>
    <van-popup v-model="showExtraGenderPicker" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="extraGenderOptions"
        @confirm="onExtraGenderConfirm"
        @cancel="showExtraGenderPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import common from '@/assets/js/common'

export default {
  name: 'ExtraInsuranceApply',
  data () {
    return {
      id: this.$route.query.id,
      planCode: '',
      pageLoading: true,
      extraApplySubmitting: false,
      extraApplyConfirmVisible: false,
      extraApplyDisclaimerAgreed: false,
      extraApplyPendingPersons: [],
      extraApplyPersons: [
        { name: '', cardtype: '1', idcard: '', birthday: '', gender: '', phone: '' },
      ],
      extraCardTypeOptions: [
        { text: '身份证', value: '1' },
        { text: '护照', value: '4' },
        { text: '其他', value: '8' },
      ],
      extraGenderOptions: ['男', '女'],
      showExtraCardTypePicker: false,
      showExtraGenderPicker: false,
      extraPickerPersonIndex: -1,
      disclaimerText:
        '追加投保为独立批次，与合同主投保互不影响；合同状态变更不会自动处理追加批次。',
      disclaimerWarnText:
        '特别提示：追加投保成功后，需在本列表单独管理撤保，不会随合同整体撤保。',
    }
  },
  created () {
    common.checkToken(this)
    if (!this.id) {
      common.mAlert(this, '合同参数缺失')
      this.goBack()
    }
  },
  mounted () {
    if (!common.getAuth()) {
      this.$router.push({ path: '/auth' })
      return
    }
    common.removeDpnClass()
    if (!this.id) {
      return
    }
    this.initPageContext()
  },
  methods: {
    goBack () {
      this.$router.push({ path: '/new_invoice', query: { id: this.id } })
    },

    initPageContext () {
      this.pageLoading = true
      common
        .cusHttp(
          this,
          '/admin_contract_insurance.php?action=list_contract_insurance_batches',
          { id: this.id, refresh: '0' },
          'get'
        )
        .then((res) => {
          const apiRes = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
          if (apiRes.errcode === 0 && apiRes.data) {
            this.planCode = apiRes.data.plan_code || ''
          } else {
            common.mAlert(this, apiRes.errmsg || '获取合同保险信息失败')
          }
        })
        .catch(() => {
          common.mAlert(this, '请求失败，请稍后重试')
        })
        .finally(() => {
          this.pageLoading = false
        })
    },

    addExtraApplyPerson () {
      this.extraApplyPersons.push({
        name: '',
        cardtype: '1',
        idcard: '',
        birthday: '',
        gender: '',
        phone: '',
      })
    },

    removeExtraApplyPerson (index) {
      this.extraApplyPersons.splice(index, 1)
    },

    extraCardTypeLabel (cardtype) {
      const item = this.extraCardTypeOptions.find((opt) => opt.value === String(cardtype))
      return item ? item.text : '身份证'
    },

    openExtraCardTypePicker (index) {
      this.extraPickerPersonIndex = index
      this.showExtraCardTypePicker = true
    },

    onExtraCardTypeConfirm (value, index) {
      const person = this.extraApplyPersons[this.extraPickerPersonIndex]
      if (person) {
        const selected = this.extraCardTypeOptions[index] || value
        person.cardtype = selected.value || selected
        if (person.cardtype === '1') {
          this.onExtraIdcardBlur(person)
        }
      }
      this.showExtraCardTypePicker = false
    },

    openExtraGenderPicker (index, person) {
      if (this.isExtraGenderAuto(person)) {
        return
      }
      this.extraPickerPersonIndex = index
      this.showExtraGenderPicker = true
    },

    onExtraGenderConfirm (value) {
      const person = this.extraApplyPersons[this.extraPickerPersonIndex]
      if (person) {
        person.gender = typeof value === 'string' ? value : value.value || value.text || ''
      }
      this.showExtraGenderPicker = false
    },

    parseExtraIdCard (idcard) {
      const no = (idcard || '').trim()
      if (no.length !== 18) {
        return null
      }
      const birthday = `${no.substr(6, 4)}-${no.substr(10, 2)}-${no.substr(12, 2)}`
      const sexCode = parseInt(no.charAt(16), 10)
      if (Number.isNaN(sexCode)) {
        return null
      }
      return {
        birthday,
        gender: sexCode % 2 === 0 ? '女' : '男',
      }
    },

    isExtraIdCardAuto (person) {
      return person.cardtype === '1' && !!this.parseExtraIdCard(person.idcard)
    },

    isExtraBirthdayAuto (person) {
      return this.isExtraIdCardAuto(person)
    },

    isExtraGenderAuto (person) {
      return this.isExtraIdCardAuto(person)
    },

    onExtraIdcardBlur (person) {
      if (person.cardtype !== '1') {
        return
      }
      const parsed = this.parseExtraIdCard(person.idcard)
      if (parsed) {
        person.birthday = parsed.birthday
        person.gender = parsed.gender
      }
    },

    formatExtraBirthday (person) {
      const value = (person.birthday || '').trim()
      if (!value) {
        return
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        person.birthday = value
        return
      }
      if (/^\d{8}$/.test(value)) {
        person.birthday = `${value.substr(0, 4)}-${value.substr(4, 2)}-${value.substr(6, 2)}`
      }
    },

    validateExtraPerson (person) {
      if (!person.name || !person.idcard) {
        return '姓名和证件号不能为空'
      }
      if (!person.phone) {
        return '手机号不能为空'
      }
      if (person.cardtype === '1') {
        const parsed = this.parseExtraIdCard(person.idcard)
        if (!parsed && (!person.birthday || !person.gender)) {
          return '身份证须为18位，或请手动填写出生日期和性别'
        }
      } else if (!person.birthday || !person.gender) {
        return '护照及其他证件须填写出生日期和性别'
      }
      return ''
    },

    openExtraApplyConfirm () {
      const persons = this.extraApplyPersons
        .map((p) => {
          this.formatExtraBirthday(p)
          this.onExtraIdcardBlur(p)
          return {
            name: (p.name || '').trim(),
            cardtype: p.cardtype || '1',
            idcard: (p.idcard || '').trim(),
            birthday: (p.birthday || '').trim(),
            gender: p.gender || '',
            phone: (p.phone || '').trim(),
          }
        })
        .filter((p) => p.name || p.idcard)

      if (!persons.length) {
        common.mAlert(this, '请至少填写一位被保险人')
        return
      }
      for (const p of persons) {
        const err = this.validateExtraPerson(p)
        if (err) {
          common.mAlert(this, err)
          return
        }
      }

      this.extraApplyPendingPersons = persons
      this.extraApplyDisclaimerAgreed = false
      this.extraApplyConfirmVisible = true
    },

    closeExtraApplyConfirm () {
      this.extraApplyConfirmVisible = false
      this.extraApplyDisclaimerAgreed = false
      this.extraApplyPendingPersons = []
    },

    handleExtraApplyConfirmClose (action, done) {
      if (action === 'confirm') {
        if (!this.extraApplyDisclaimerAgreed) {
          common.mAlert(this, '请先阅读并勾选同意免责声明')
          done(false)
          return
        }
        this.confirmExtraApply().finally(() => done())
        return
      }
      this.closeExtraApplyConfirm()
      done()
    },

    confirmExtraApply () {
      if (!this.extraApplyPendingPersons.length) {
        return Promise.resolve()
      }

      this.extraApplySubmitting = true
      return common
        .cusHttp(
          this,
          '/admin_contract_insurance.php?action=apply_extra_contract_insurance',
          {
            id: this.id,
            persons: this.extraApplyPendingPersons,
          },
          'post'
        )
        .then((res) => {
          const apiRes = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
          if (apiRes.errcode === 0) {
            common.mAlert(this, '追加投保已提交')
            this.closeExtraApplyConfirm()
            this.goBack()
          } else {
            common.mAlert(this, apiRes.errmsg || '追加投保失败')
          }
        })
        .catch(() => {
          common.mAlert(this, '追加投保请求失败，请稍后重试')
        })
        .finally(() => {
          this.extraApplySubmitting = false
        })
    },
  },
}
</script>

<style scoped>
.extra-page-loading {
  display: block;
  text-align: center;
  padding: 0.8rem 0;
}

.extra-plan-hint {
  font-size: 0.26rem;
  color: #999;
  margin-bottom: 0.16rem;
}

.extra-person-block {
  margin-bottom: 0.2rem;
  border: 1px solid #f0f0f0;
  border-radius: 0.16rem;
  overflow: hidden;
  background: #fff;
}

.extra-person-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem 0.3rem;
  background: #fafafa;
  font-size: 0.28rem;
  font-weight: 500;
}

.extra-confirm-body {
  padding: 12px 16px 4px;
}

.extra-confirm-disclaimer {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
  margin: 0 0 8px;
}

.extra-confirm-warning {
  font-size: 13px;
  color: #ee0a24;
  line-height: 1.5;
  margin: 0 0 12px;
}
</style>
